import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import FollowupCampaignList from './FollowupCampaignList';
import FollowupEditor from './FollowupEditor';
import FollowupHistoryTab from './FollowupHistoryTab';
import FollowupEvaluationTab from './FollowupEvaluationTab';

const SUBTAB_NAMES = ['campaigns', 'history', 'evaluation'] as const;

interface FollowupTabProps {
  subtab?: string;
  editId?: string | null;
  onSubtabChange?: (subtab: string) => void;
  onEditChange?: (editId: string | null) => void;
}

const FollowupTab: React.FC<FollowupTabProps> = ({
  subtab = 'campaigns',
  editId,
  onSubtabChange,
  onEditChange,
}) => {
  // Derive innerTab from subtab prop
  const innerTab = Math.max(0, SUBTAB_NAMES.indexOf(subtab as (typeof SUBTAB_NAMES)[number]));

  // Editor mode from editId prop
  const showEditor = editId !== null && editId !== undefined;
  const editingCampaignId = editId === 'new' ? null : editId ? parseInt(editId, 10) : null;

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    onSubtabChange?.(SUBTAB_NAMES[newValue]);
  };

  const handleNew = () => {
    onEditChange?.('new');
  };

  const handleEdit = (campaignId: number) => {
    onEditChange?.(String(campaignId));
  };

  const handleSaved = () => {
    onEditChange?.(null);
  };

  const handleCancel = () => {
    onEditChange?.(null);
  };

  // If in editor mode, show editor full screen (no tabs)
  if (showEditor) {
    return (
      <Box>
        <FollowupEditor
          campaignId={editingCampaignId}
          onSaved={handleSaved}
          onCancel={handleCancel}
        />
      </Box>
    );
  }

  return (
    <Box>
      <Tabs
        value={innerTab}
        onChange={handleTabChange}
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        <Tab label="Kampagnen" />
        <Tab label="Verlauf" />
        <Tab label="Auswertung" />
      </Tabs>

      {innerTab === 0 && <FollowupCampaignList onEdit={handleEdit} onNew={handleNew} />}
      {innerTab === 1 && <FollowupHistoryTab />}
      {innerTab === 2 && <FollowupEvaluationTab />}
    </Box>
  );
};

export default FollowupTab;
